import React, { useEffect, useState } from "react";
import { Grid, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { CiCircleQuestion } from "react-icons/ci";
import { GreenColorButton, DarkGreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomModal from "../../Components/Modal/CustomModal";
import { PostMethod } from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader"
import { toast } from "react-toastify";

const ComputerBasedTest = () => {

  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false)
  const [JobDetails, setJobDetails] = useState()
  const UserID = localStorage.getItem("@userid")

  const HandleStartTest = () => {
    setConfirmationModal(false);
    navigate("/questionspage");
  }
  useEffect(()=>{
    GetCBTDetails()
  },[])
  const GetCBTDetails = async()=>{
    try{
      let url ="test/computertestlist"
      let method ="POST"
      let params ={
        candidate_uuid:UserID
      }
      setShowLoader(true)
      const response =await PostMethod({url,method,params})
      if(response.status){
        setShowLoader(false)
        if(response.result[0]){
          setJobDetails(response.result[0])
        }
      }else{
        setShowLoader(false)
      }
    }catch(Error){
      setShowLoader(false)
      console.log("Error Something went wrong",Error)
    }
  }
  const StartTest=()=>{
    let Start_Date = JobDetails?.computer_test_date
    if(Start_Date){
      let Current_Date = (new Date(Start_Date)).getTime()
      let today = Date.now()
      if(today>Current_Date){
        setConfirmationModal(true)
      }else{
        toast.warn("Computer Based Test Not Started Yet")
      }
    }else{
      toast.warn("Computer Based Test Not Started Yet")
    }

  }
  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} >
      <Grid container item lg={12} sm={12} md={12} xs={12} alignItems={"center"} >
        <button
          className="btn btn-0 border-0 ButtonFoucusNone"
        >
          <FaArrowLeft color="#222222" size={"20px"} />
        </button>
        <h4 className="poppinsMedium Text-Prime-Black text-center">Take Computer Based Test</h4>
      </Grid>
      <Grid item container lg={12} md={128} sm={12} className="bg-white p-3 borderRadius10 mt-3">
        <Grid item container lg={12} md={12} sm={12} xs={12}>
          <Grid item lg={12} sm={12} md={12} xs={12} container justifyContent={"space-between"} alignItems={"center"}>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsMedium Text-Prime-Black text-left pb-2">Name of the Post Applying for</p>
              </Grid>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{JobDetails?.job_name}</p>
              </Grid>
            </Grid>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
              <Grid item container lg={6} justifyContent={"flex-start"} >
                <p className="poppinsMedium Text-Prime-Black text-left pb-2">Number of Questions</p>
              </Grid>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{JobDetails?.mcq_qus_count} Questions</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsMedium Text-Prime-Black text-left pb-2">Test Date</p>
              </Grid>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{JobDetails?.computer_test_date}</p>
              </Grid>
            </Grid>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsMedium Text-Prime-Black text-left pb-2">Time Duration</p>
              </Grid>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{JobDetails?.mcq_test_duration} Minutes</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"}>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsMedium Text-Prime-Black text-left pb-2">Test Venue</p>
              </Grid>
              <Grid item container lg={6} justifyContent={"flex-start"}>
                <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{ JobDetails?.computer_locations? JobDetails?.computer_locations[0]?.value:"--"}</p>
              </Grid>
            </Grid>
            <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"}>
            </Grid>
          </Grid>
          <Grid item container lg={12} md={12} sm={12} alignItems={"center"}>
            <h4 className="Text-Prime-Black poppinsSemiBold text-left pl-2">Instructions:</h4>
          </Grid>
          <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">1. Read Each Question Carefully</h5>
            <p className="poppinsRegular text-black text-left pt-1">Please take your time to read each question carefully before selecting an answer. Incorrect answers may affect your score.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">2. Answer All Questions</h5>
            <p className="poppinsRegular text-black text-left pt-3">You must answer all 50 questions. You cannot skip or return to previous questions once you&apos;ve moved on.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">3. Time Management</h5>
            <p className="poppinsRegular text-black text-left pt-1">The test will automatically submit when the time reaches 60 minutes. Make sure to pace yourself and keep an eye on the timer.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">4. No External Help</h5>
            <p className="poppinsRegular text-black text-left pt-1">Only your knowledge and memory should be used to answer the questions. External resources (e.g., textbooks, websites) are not allowed.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">5. Submitting Your Test</h5>
            <p className="poppinsRegular text-black text-left pt-1">Once you have answered all the questions, you can submit your test. Ensure you&apos;re satisfied with your answers before submission.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">6. Timer Activation</h5>
            <p className="poppinsRegular text-black text-left pt-1">Once you start the test, the timer will automatically start counting down. Be prepared to begin as soon as you click &quot;Start Test.&quot;</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container justifyContent={"center"}>
            {JobDetails?.computer_test_date&& <GreenColorButton className="px-4 py-2" onClick={() => StartTest() }>Start Test</GreenColorButton>}
          </Grid>
        </Grid>
      </Grid>
      <CustomModal
        open={confirmationModal}
        setOpen={setConfirmationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular text-black pt-3 text-center">Start Test Confirmation</p>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <p className="poppinsRegular text-black text-left pb-3">You are about to start the test. Please ensure you have read all the instructions carefully and are ready to begin. Once the test starts:</p>
            <ul>
              <li className="poppinsRegular text-black text-left pb-3">The timer will automatically begin counting down.</li>
              <li className="poppinsRegular text-black text-left pb-3">You cannot pause or restart the test.</li>
              <li className="poppinsRegular text-black text-left">Navigation away from the test window is not allowed.</li>
            </ul>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              className="px-5 py-2"
              onClick={() => setConfirmationModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              className="px-3 py-2 ml-2"
              onClick={() => HandleStartTest()}
            >
              Yes, Start Test
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid>
  );
};

export default ComputerBasedTest;
